import React, { useState, useEffect, useContext } from "react";
import { Routes, Route, useParams } from "react-router-dom";
import "../../../styles/Typography.css";
import TypographyHeader from "./TypographyHeader";
import TypographyImport from "./TypographyImport";
import TypographySizes from "./TypographySizes";
import TypographyTypefaces from "./TypographyTypefaces";
import { ClientContext } from "../../../contexts/ClientContext";

const TypographyApp = () => {
  const [fonts, setFonts] = useState();
  const [currentFont, setCurrentFont] = useState("");
  const [currentProjectId, setCurrentProjectId] = useState("");
  const [projectIds, setProjectIds] = useState([]);
  const [mobileInputs, setMobileInputs] = useState({});
  const [desktopInputs, setDesktopInputs] = useState({});
  const [smallTypeSizeTags, setSmallTypeSizeTags] = useState([]);
  const [mediumTypeSizeTags, setMediumTypeSizeTags] = useState([]);
  const [typographyAssignments, setTypographyAssignments] = useState({});

  const { updateTypographySet, currentClient, getClient, setCurrentClientId, currentClientId } =
    useContext(ClientContext);
  const { clientid } = useParams();

  useEffect(() => {
    if (currentClient && "Typography" in currentClient) {
      setMobileInputs(currentClient.Typography[0].data.mobileInputs || {});
      setDesktopInputs(currentClient.Typography[0].data.desktopInputs || {});
      setProjectIds(currentClient.Typography[0].data.projectIds || []);
      setTypographyAssignments(currentClient.Typography[0].data.typographyAssignments || {});
      setSmallTypeSizeTags(currentClient.Typography[0].data.smallTypeSizeTags || []);
      setMediumTypeSizeTags(currentClient.Typography[0].data.mediumTypeSizeTags || []);
    } else if (!currentClient && clientid) {
      getClient(clientid);
    }
  }, [currentClient]);

  useEffect(() => {
    if (clientid && !currentClientId) {
      setCurrentClientId(clientid);
    }
  }, []);

  useEffect(() => {
    if (
      projectIds.length > 0 ||
      Object.keys(mobileInputs).length !== 0 ||
      Object.keys(desktopInputs).length !== 0
    ) {
      const data = {
        projectIds: projectIds,
        mobileInputs: mobileInputs,
        desktopInputs: desktopInputs,
        typographyAssignments: typographyAssignments,
        smallTypeSizeTags: smallTypeSizeTags,
        mediumTypeSizeTags: mediumTypeSizeTags,
      };
      updateTypographySet(data);
    }
  }, [
    projectIds,
    mobileInputs,
    desktopInputs,
    typographyAssignments,
    smallTypeSizeTags,
    mediumTypeSizeTags,
  ]);

  useEffect(() => {
    if (currentProjectId) {
      var head = document.head;
      var link = document.createElement("link");

      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = "https://use.typekit.net/" + currentProjectId + ".css";

      head.appendChild(link);

      return () => {
        head.removeChild(link);
      };
    }
  }, [currentProjectId]);

  useEffect(() => {
    if (fonts && !currentFont) {
      setCurrentFont(fonts.kit.families[0].css_names[0]);
    }
  }, [fonts, currentFont]);

  return (
    <div className="typography-container">
      <TypographyHeader currentProjectId={currentProjectId} />
      <Routes>
        <Route
          path="/"
          element={
            <TypographyImport
              setFonts={setFonts}
              currentProjectId={currentProjectId}
              setCurrentProjectId={setCurrentProjectId}
              projectIds={projectIds}
              setProjectIds={setProjectIds}
            />
          }
        />
        <Route
          path="/sizes"
          element={
            <TypographySizes
              fonts={fonts}
              currentFont={currentFont}
              setCurrentFont={setCurrentFont}
              mobileInputs={mobileInputs}
              setMobileInputs={setMobileInputs}
              desktopInputs={desktopInputs}
              setDesktopInputs={setDesktopInputs}
              setSmallTypeSizeTags={setSmallTypeSizeTags}
              setMediumTypeSizeTags={setMediumTypeSizeTags}
            />
          }
        />
        <Route
          path="/typefaces"
          element={
            <TypographyTypefaces
              fonts={fonts}
              setTypographyAssignments={setTypographyAssignments}
              typographyAssignments={typographyAssignments}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default TypographyApp;
